import { fetchCubaBannerInfo } from '@/api/marketplace'
import { fiveMinutesPolicyHasExpired } from '@/utils/cachePolicies'
import { isCurrentDateBetween } from '@/utils/date'
const fetchForBannerVisibility = async ({ commit, state }, countryId) => {
  if (fiveMinutesPolicyHasExpired(state.lastFetchDate)) {
    try {
      let response = await fetchCubaBannerInfo(countryId)
      let showPrebookingBanner = false
      let showPromotionBanner = false
      if (!response.errors) {
        if (
          response.data &&
          response.data.preBookings &&
          response.data.preBookings.search &&
          response.data.preBookings.search.length > 0
        ) {
          showPrebookingBanner = true
        }
        if (
          response.data &&
          response.data.promotions &&
          response.data.promotions.search &&
          response.data.promotions.search.length > 0
        ) {
          const promotions = response.data.promotions.search
          const anyValidPromotion = promotions.filter(promotion => isCurrentDateBetween(promotion.startAt, promotion.endAt))
          if (anyValidPromotion && anyValidPromotion.length > 0) {
            showPromotionBanner = true
          }
        }
        commit('SET_BANNER', { showPrebookingBanner, showPromotionBanner })
      } else {
        throw response.errors
      }
    } catch (ex) {
      console.log(ex)
    }
  }
}
export default {
  fetchForBannerVisibility
}



// WEBPACK FOOTER //
// ./src/store/modules/banner/actions.js